<template lang="html">
	<div id="page__noforwarding__report" class="center-panel">
		<md-content md-theme="white" class="md-elevation-1" v-loader-overlay="progress">
			<sort-table
				v-bind:columns="tableColumns" v-model="reports" v-on:refresh="getReports" v-bind:per-page="perPage" 
				v-bind:total="reportsAmount" table-id="report-noforwarding" default-order="desc" default-sort="id"
				v-bind:showAddButton="false" v-bind:noBreackColumns="['traking_number', 'id']" v-bind:refreshOnCreate="false"
			>
				<template slot="buttons">
					<z-button v-if="canPrintNoForwardingReport" v-on:click="printNoForwardingReport"> Распечатать </z-button>
				</template>

				<template slot="weight" slot-scope="scope">
					<span v-if="scope.item.weight"> {{scope.item.weight}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="size" slot-scope="scope">
					<span v-if="scope.item.size"> {{scope.item.size}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="from" slot-scope="scope">
					<span clas="no-break-hidden" v-if="scope.item.from"> {{scope.item.from.value}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="to" slot-scope="scope">
					<span clas="no-break-hidden" v-if="scope.item.to"> {{scope.item.to.value}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="payer" slot-scope="scope">
					<span class="no-break-hidden" v-if="scope.item.payer"> {{scope.item.payer.name}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="payment_method" slot-scope="scope">
					<span v-if="scope.item.payment_method"> {{scope.item.payment_method.name}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="nds" slot-scope="scope">
					<span> {{ scope.item.nds }} </span>
				</template>

				<template slot="status" slot-scope="scope">
					<span v-if="scope.item.status" v-bind:style="'color: ' + scope.item.status.color + ';'"> {{scope.item.status.name}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="trackig" slot-scope="scope">
					<div class="route-list-item" v-if="scope.item.from_trackig"> 
						<md-tooltip v-if="scope.item.from_trackig.route_list" md-direction="bottom"> {{ getRLStatus(scope.item.from_trackig.route_list.status_id) }} </md-tooltip>
						<span class="from label"> Забор </span>
						<span class="route-list" v-if="scope.item.from_trackig.route_list_id"> {{'МЛ ' + scope.item.from_trackig.route_list_id}} </span>
						<span v-else class="route-list"> Без МЛ </span>
						<span class="date"> {{ moment(scope.item.from_trackig.date).tz($root.userTimezone).format('DD.MM.YYYY') }} </span>
						<span v-if="scope.item.from_trackig.responsible" class="forwarder"> {{(scope.item.from_trackig.responsible.fio) ? scope.item.from_trackig.responsible.fio : scope.item.from_trackig.responsible.login}} </span>
					</div>
					<div class="route-list-item" v-if="scope.item.to_trackig">
						<md-tooltip v-if="scope.item.to_trackig.route_list" md-direction="bottom"> {{ getRLStatus(scope.item.to_trackig.route_list.status_id) }} </md-tooltip>
						<span class="to label"> Выдача </span>
						<span class="route-list" v-if="scope.item.to_trackig.route_list_id"> {{'МЛ ' + scope.item.to_trackig.route_list_id}} </span>
						<span v-else class="route-list"> Без МЛ </span>
						<span class="date"> {{ moment(scope.item.to_trackig.date).tz($root.userTimezone).format('DD.MM.YYYY') }} </span>
						<span class="forwarder" v-if="scope.item.to_trackig.responsible"> {{(scope.item.to_trackig.responsible.fio) ? scope.item.to_trackig.responsible.fio : scope.item.to_trackig.responsible.login}} </span>
					</div>
				</template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import SortTable from "@/components/SortTable"
	import reportsMenu from './reports-menu';
	import ZButton from '@/components/ZButton.vue';
	export default {
		components: { SortTable, reportsMenu, ZButton },
		data() {
			return {
				tableColumns: [
					{ label: 'Треккод',     field: 'traking_number',  sortable: true},
					
					{ label: 'Мест', field: 'seats_number',  sortable: true},
					{ label: 'Вес (кг)',    field: 'weight',  sortable: true},
					{ label: 'Объём (м<sup>3</sup>)', field: 'size',  sortable: true},
					
					
					{ label: 'Отправление', field: 'from'},
					{ label: 'Назначение', field: 'to'},
					{ label: 'Маршрутные листы', field: 'trackig'},

					{ label: 'Плательщик', field: 'payer'},
					{ label: 'НДС', field: 'nds'},

					{ label: 'Основная сумма (руб.)', field: 'price_default'},
					{ label: 'Отправление (руб.)', field: 'price_forwarding_from'},
					{ label: 'Назначение (руб.)', field: 'price_forwarding_to'},
					{ label: 'Прочее (руб.)', field: 'price_other'},
					{ label: 'Сумма (руб.)', field: 'price_full'},
					{ label: 'Способ оплаты', field: 'payment_method'},

					{ label: 'Статус', field: 'status', sortable: true},
					{ label: '', field: 'actions'}
				],
				RLStatuses: [
					{id: 1, label: 'Создан'},
					{id: 2, label: 'В работе'},
					{id: 3, label: 'Машина принята'},
					{id: 4, label: 'Выдан на перемещение'},
					{id: 5, label: 'Выполнен'}
				],
				currentPage: 1,
				perPage: 50,
			}
		},
		created() {
			this.$store.commit('setTitle', 'Отчет по экспедированию');
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-noforwarding-reports'];
			},
			/**
			 * Объект флагов загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список отчетов
			 */
			reports() {
				return this.$store.state.reports.noforwarding_report;
			},
			/**
			 * Количество отчетов
			 */
			reportsAmount() {
				return this.$store.state.reports.noforwarding_report_amount;
			},
			canPrintNoForwardingReport() {
				if (!this.$route.query || !this.$route.query.custom_filter) return;
				let filter = JSON.parse(this.$route.query.custom_filter);
				return Object.values(filter).find(item => !!item);
			}
		},
		methods: {
			/**
			 * Получение статуса из урла
			 */
			getRLStatus(id) {
				let status = this.RLStatuses.find(status => parseInt(status.id) === parseInt(id));
				return (status && status.label) ? ('Статус: ' + status.label) : 'Статус: не указан';
			},
			/**
			 * Получение отчетов
			 */
			getReports(page, count, orderBy, orderType) {
				this.$store.commit('showProgressBar', 'get-noforwarding-reports');

				let filter = (this.$route.query && this.$route.query.custom_filter) ? JSON.parse(this.$route.query.custom_filter) : {};
				if (filter.date_from) filter.date_from = this.moment(filter.date_from).tz(this.$root.userTimezone).format('YYYY-MM-DD');
				if (filter.date_to)   filter.date_to   = this.moment(filter.date_to).tz(this.$root.userTimezone).format('YYYY-MM-DD');

				let data = {
					page:       (page)      ? page      : 1, 
					order_by:   (orderBy)   ? orderBy   : 'id', 
					order_type: (orderType) ? orderType : 'desc',
					count:      (count)     ? count     : 50,
					custom_filter: filter
				};
				return this.$store.dispatch('reports/getNoForwardingReport', data)
					.finally(() => this.$store.commit('hideProgressBar', 'get-noforwarding-reports'));
			},
			/**
			 * Печать отчета
			 */
			printNoForwardingReport() {
				this.printUserReport('noforwarding-report');
			},
			/**
			 * Метод для печати отчета
			 */
			printUserReport(type = null) {
				if (!type || !this.$route.query || !this.$route.query.custom_filter) return;
				let filter = JSON.parse(this.$route.query.custom_filter);
				if (!filter) return;

				let query = [('custom_filter=' + JSON.stringify(filter))];
				if (this.$route.query.orderBy)   query.push('order_by='   + this.$route.query.orderBy);
				if (this.$route.query.orderType) query.push('order_type=' + this.$route.query.orderType);
				
				let url = this.$store.state.endpoint + '/report/excel/' + type + '?' + query.join('&');
				window.open(url, '_blank').focus();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// NoForwardingReport.vue?86e30a3c